const shape = {
  // Default material-ui border-radius:
  borderRadius: 4,
  // Custom border-radius:
  borderRadiusLarge: 8,
};

export default shape;
